export default __webpack_public_path__ + "static/media/ic_chevron_up_sm.bbe115dd.svg";